export { default } from './ThemeProvider';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/ThemeProvider/index.js
// module id = 845
// module chunks = 121